export enum MatchIconType {
  Success,
  Warning,
  Error
}
